'use client'
import { Col } from '@repo/ui/components'
import { ProjectsAvailableProperties } from './add-projects.properties'

export const AddProjectsContainer = () => {
  return (
    <Col className='gap-3xl w-full mb-8xl md:mb-0'>
      <ProjectsAvailableProperties />
    </Col>
  )
}
